<script setup lang="ts">
import { useGuestStore } from '@/store/guest';
import AppTypography from '../base/AppTypography.vue';

const { guestPrompt } = storeToRefs(useGuestStore());
const router = useRouter();

const guestNavigateTo = (to: string) => {
  router.push(to);
  guestPrompt.value = false;
};
</script>

<template>
  <v-dialog v-model="guestPrompt" width="auto" class="guest-prompt" :max-width="295" persistent>
    <v-card>
      <v-card-text class="guest-prompt__content">
        <AppTypography type="title-3" class="mb-2">Sign in to continue</AppTypography>
        <AppTypography type="subheadline-2" class="text--tertiary">
          Please log in or create an account to continue.
        </AppTypography>
      </v-card-text>

      <v-list class="guest-prompt__action-list" attach>
        <v-list-item @click="guestNavigateTo('/login')">
          <AppTypography type="body-1" class="text--secondary">Sign in</AppTypography>
        </v-list-item>
        <v-list-item @click="guestNavigateTo('/register')">
          <AppTypography type="body-1" class="text--secondary">Create an Account</AppTypography>
        </v-list-item>
        <v-list-item @click="guestPrompt = false">
          <AppTypography type="body-2" class="text--secondary">Cancel</AppTypography>
        </v-list-item>
      </v-list>
    </v-card>
  </v-dialog>
</template>

<style lang="scss">
.guest-prompt {
  text-align: center;

  .guest-prompt__content {
    padding: 32px 16px 24px 16px !important;
  }

  .guest-prompt__action-list {
    .v-list-item {
      min-height: 56px !important;
      border-top: 1px solid rgb(var(--v-theme-stroke));
    }
  }
}
</style>
